import React from "react";

const Footer = () => {
  return (
    <footer className='bg-white text-white py-2 shadow-xl'>
      <div className='container mx-auto text-center text-sm text-black'>
        <p>&copy; 2025 Shiva Group. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
